import * as React from 'react';

import {Popover} from 'shells/popover/popover';

// @ts-expect-error
import {CopyRegularIcon} from '../../../../client_modules/shells/react/components/icon/svg/copy-regular-icon';
import {Link} from '../../../../client_modules/shells/react/components/link/link';

type PreferenceCenterLinkCopyProps = {
    link: string;
};

export function PreferenceCenterLinkCopy(props: PreferenceCenterLinkCopyProps) {
    const containerRef = React.useRef<HTMLDivElement | null | undefined>(null);
    const [showCopiedMessage, setShowCopiedMessage] = React.useState<boolean>(false);

    const handleCopy = (event: React.SyntheticEvent<any>) => {
        event.preventDefault();
        event.stopPropagation();

        navigator.clipboard.writeText(props.link).then(() => {
            setShowCopiedMessage(true);
            setTimeout(() => {
                setShowCopiedMessage(false);
            }, 2000);
        });
    };

    return (
        // @ts-expect-error
        <div ref={containerRef} className='inline-block'>
            <Link
                variant='primary'
                size='small'
                onClick={handleCopy}
                as='button'
                // @ts-expect-error
                style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer'}}
            >
                Copy preference center link{' '}
                <CopyRegularIcon wrapWithDiv={false} alignCenter={true} size={14} />
            </Link>
            {showCopiedMessage && containerRef.current && (
                <Popover anchor={containerRef.current} bodyColor='dark' location='top'>
                    <div className='pad-8'>Copied to clipboard!</div>
                </Popover>
            )}
        </div>
    );
}
